module.exports = __webpack_public_path__ + "static/media/icon_health.d9d55e56.svg";